// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-main .dashboard-wrapper .main-section {
  justify-content: space-between;
}
.dashboard-main .dashboard-wrapper .left-section {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px;
}
.dashboard-main .dashboard-wrapper .left-section h5 {
  color: #44667f;
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: 600;
  border-bottom: 1px solid #898e8e;
  padding: 0 15px 15px 15px;
}
.dashboard-main .dashboard-wrapper .right-section {
  width: calc(50% - 5px);
  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px;
}
.dashboard-main .dashboard-wrapper .right-section .ineerCard .innerText {
  background-color: #747b26;
}
.dashboard-main .dashboard-wrapper .right-section .ineerCard .innerText .headingText,
.dashboard-main .dashboard-wrapper .right-section .ineerCard .innerText .count {
  color: #ffffff !important;
}
.dashboard-main .dashboard-wrapper .right-section .ineerCard .innerIcon {
  background-color: #ffffff !important;
}
.dashboard-main .dashboard-wrapper .right-section h5 {
  color: #44667f;
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: 600;
  border-bottom: 1px solid #898e8e;
  padding: 0 15px 15px 15px;
}
.dashboard-main .dashboard-wrapper .rc-kpi-row > [class*=col-] {
  display: flex;
}
.dashboard-main .dashboard-wrapper .rc-kpi-row .mainCards {
  width: 100%;
  display: flex;
}
.dashboard-main .dashboard-wrapper .rc-kpi-row .ineerCard {
  height: 100%;
  margin-bottom: 0;
  justify-content: flex-start;
}
.dashboard-main .dashboard-wrapper .rc-kpi-row .chart-heading {
  min-height: 34px;
}
.dashboard-main .dashboard-wrapper .mainCards {
  text-decoration: none;
}
.dashboard-main .dashboard-wrapper .mainCards .ineerCard {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  max-height: 500px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px 0px 15px 5px;
  cursor: pointer;
  background-color: #fff;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  border: 0px solid transparent;
  border-radius: 0.75rem;
}
.dashboard-main .dashboard-wrapper .mainCards .ineerCard .innerIcon.Basic {
  background: linear-gradient(180deg, #03a731 0%, #027221 100%);
}
.dashboard-main .dashboard-wrapper .mainCards .ineerCard .innerIcon.Basic-plus {
  background: linear-gradient(180deg, #fdd504 0%, #b37600 100%);
}
.dashboard-main .dashboard-wrapper .mainCards .ineerCard .innerIcon.Premium-User {
  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);
}
.dashboard-main .dashboard-wrapper .mainCards .ineerCard .innerIcon {
  background: #055d9d;
  width: 25%;
  text-align: center;
  line-height: 80px;
}
.dashboard-main .dashboard-wrapper .mainCards .ineerCard .innerIcon svg {
  text-align: center;
  vertical-align: middle;
  margin-top: 10px;
  height: 50px;
  width: 50px;
  line-height: 80px;
}
.dashboard-main .dashboard-wrapper .mainCards .innerText {
  width: 75%;
  padding: 12px 50px 12px 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.dashboard-main .dashboard-wrapper .mainCards .innerText .headingText {
  color: #013053;
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
}
.dashboard-main .dashboard-wrapper .mainCards .innerText .count {
  margin-top: 0px;
  font-size: 26px;
  font-weight: 600;
  color: #013053;
  text-align: end;
}

.heading-btn-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.heading-common label {
  font-size: 24px;
  font-weight: 700;
  color: #84859d;
}

.chart-heading {
  padding: 10px;
}
.chart-heading label {
  font-size: 16px;
  font-weight: 700;
  color: #84859d;
}

.buttons-modal button,
.buttons-modal a {
  text-decoration: none;
  border: none;
  background-color: #44667f;
  color: #fff;
  border-radius: 10px;
  padding: 5px 15px;
}

.admin-main .add-btn {
  text-align: end;
}
.admin-main .add-btn button {
  border: none;
  color: #fff;
  border-radius: 5px;
  padding: 7px 10px;
  background-color: #84859d;
}
.admin-main .add-btn button:hover {
  background-color: #696a7d;
}
.admin-main .add-btn button svg {
  height: 20px;
  margin-bottom: 2px;
}

.table-wrapper {
  overflow-x: auto;
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
}
.table-wrapper table {
  min-width: 900px;
}
.table-wrapper table thead {
  background-color: #44667f;
}
.table-wrapper table thead th {
  color: #fff;
}
.table-wrapper table .verify a {
  display: inline-block;
  width: 130px;
  padding: 3px;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  background-color: #84859d;
}
.table-wrapper table .verify a:hover {
  background-color: #696a7d;
}
.table-wrapper table .action .icon {
  margin: 0 3px;
  padding: 2px 5px;
  border-radius: 5px;
  background-color: #84859d;
}
.table-wrapper table .action .icon img {
  height: 18px;
  width: 18px;
  vertical-align: middle;
}

table.dataTable thead th {
  text-align: center;
}

.dataTables_wrapper .dataTables_length {
  margin-bottom: 20px;
}

.dataTables_wrapper .dataTables_length select {
  margin-left: 10px;
  width: 150px;
  outline: none;
}

.dataTables_wrapper .dataTables_filter input {
  outline-offset: 0px;
  outline: none;
}

.dataTables_empty {
  color: red;
}

.dataTables_wrapper .dataTables_paginate {
  margin-top: 20px;
}

.dataTables_wrapper .dataTables_paginate .paginate_button.current {
  background-color: #44667f;
  color: #fff !important;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {
  background-color: #44667f;
  color: #fff !important;
}

.dataTables_wrapper .dataTables_info {
  margin-top: 20px;
}

.heading-btn-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.heading-common label {
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 700;
  color: #013053;
  letter-spacing: 1px;
}

.buttons-modal button {
  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);
  border-radius: 10px 0px;
}
.buttons-modal a {
  background-color: #055d9d !important;
}
.buttons-modal button,
.buttons-modal a {
  text-decoration: none;
  border: none;
  color: #fff;
  border-radius: 5px;
  width: 100px;
  display: inline-flex;
  justify-content: center;
  padding: 5px 15px;
}

.admin-main .add-btn {
  text-align: end;
}
.admin-main .add-btn button {
  border: none;
  color: #fff;
  padding: 7px 10px;
  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);
  border-radius: 10px 0px;
}
.admin-main .add-btn button:hover {
  background-color: #afb57d;
}
.admin-main .add-btn button svg {
  height: 20px;
  margin-bottom: 2px;
}
.admin-main .add-btnFalse {
  text-align: end;
}
.admin-main .add-btnFalse button {
  border: none;
  color: #fff;
  padding: 7px 10px;
  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);
  opacity: 0.5;
  border-radius: 10px 0px;
}
.admin-main .add-btnFalse button:hover {
  background-color: #afb57d;
}
.admin-main .add-btnFalse button svg {
  height: 20px;
  margin-bottom: 2px;
}

.table-wrapper {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
}
.table-wrapper .main-data-wrapper {
  max-height: calc(100vh - 324px);
  overflow: auto;
}
.table-wrapper table {
  width: 100%;
  margin-bottom: 0;
  min-width: 800px;
}
.table-wrapper table td {
  color: #013053 !important;
}
.table-wrapper table thead {
  background-color: rgba(0, 126, 204, 0.3411764706);
}
.table-wrapper table thead th {
  color: #055d9d;
  font-weight: 600;
}
.table-wrapper table .action .view {
  background-color: #e40288;
}
.table-wrapper table .action .view:hover {
  background-color: rgba(228, 2, 138, 0.5137254902);
  transition: all 0.2s;
}
.table-wrapper table .action .edit {
  background-color: #e40288;
}
.table-wrapper table .action .edit:hover {
  background-color: rgba(228, 2, 138, 0.5137254902);
  transition: all 0.2s;
}
.table-wrapper table .action .delete {
  background-color: #e40288;
}
.table-wrapper table .action .delete:hover {
  background-color: rgba(228, 2, 138, 0.5137254902);
  transition: all 0.2s;
}
.table-wrapper table .action .icon {
  margin: 0 3px;
  padding: 2px 5px;
  border-radius: 5px;
}
.table-wrapper table .action .icon img {
  height: 18px;
  width: 18px;
  vertical-align: middle;
}

.dataTables_wrapper .dataTables_length {
  margin-bottom: 20px;
}

.dataTables_wrapper .dataTables_length select {
  margin-left: 10px;
  width: 150px;
  outline: none;
  border-radius: 10px;
}

.dataTables_wrapper .dataTables_filter input {
  outline-offset: 0px;
  outline: none;
  border-radius: 10px;
}

.dataTables_empty {
  color: red;
}

.dataTables_wrapper .dataTables_paginate {
  margin-top: 20px;
}

.dataTables_wrapper .dataTables_paginate .paginate_button.current {
  background: #055d9d;
  color: #fff !important;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {
  background-color: #055d9d;
  color: #fff !important;
}

.dataTables_wrapper .dataTables_info {
  margin-top: 20px;
}

.modal-content .plus-btn button,
.modal-content .minus-btn button {
  font-size: 15px;
  font-weight: 700;
}
.modal-content .add-newSabaq-btn {
  text-decoration: none;
  width: calc(100% - 1.8rem);
  margin: 0 0.9rem 15px 0.9rem;
  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);
  border-radius: 10px 0px;
}
.modal-content .sub-group-main {
  margin-bottom: 15px !important;
  margin: 0 0.9rem;
  padding: 10px;
  width: calc(100% - 1.8rem);
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.modal-content .p-details-img {
  display: flex;
  flex-wrap: wrap;
}
.modal-content .p-details-img img {
  height: 90px;
  width: 90px;
  border-radius: 10px;
  margin-right: 15px;
}
.modal-content .product-img-main {
  flex-wrap: wrap;
  margin: 40px 0 30px 0;
}
.modal-content .product-img-main .products {
  margin-right: 20px;
  margin-bottom: 20px;
  width: 90px;
  height: 90px;
  padding: 10px 0;
  text-align: center;
  position: relative;
  border: 1px dashed gray;
  border-radius: 10px;
}
.modal-content .product-img-main .products .cross {
  position: absolute;
  right: -8px;
  top: -8px;
  height: 15px;
  width: 15px;
}
.modal-content .product-img-main .products span {
  font-size: 11px;
  color: gray;
  display: block;
}
.modal-content .product-img-main .products svg {
  display: inline-block;
  height: 50px;
  width: 50px;
}
.modal-content .product-img-main .products .img-product {
  height: 70px;
  width: 70px;
}
.modal-content .details-input {
  width: calc(100% - 70px);
}
.modal-content .details-input .remove {
  cursor: pointer;
  position: absolute;
  right: -55px;
  bottom: 7px;
}
.modal-content .details-input .remove img {
  height: 20px;
  width: 20px;
}
.modal-content .modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #013053;
  text-transform: capitalize;
}
.modal-content .check-input {
  cursor: pointer;
  margin-left: 30px;
  margin-top: 8px;
  display: flex;
  align-items: center;
}
.modal-content .check-input .form-check-input {
  height: 30px !important;
  width: 30px;
  margin-right: 10px;
}
.modal-content .user-detail {
  margin-bottom: 15px;
}
.modal-content .user-detail label {
  color: #84859d;
  font-size: 14px;
}
.modal-content .user-detail span,
.modal-content .user-detail p {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
}
.modal-content .table-user-details {
  overflow-x: auto;
}
.modal-content .table-user-details table {
  border: 1px solid #44667f;
  border-collapse: collapse;
  min-width: 1000px;
  width: 100%;
}
.modal-content .table-user-details table th,
.modal-content .table-user-details table td {
  padding: 7px 10px;
  border: 1px solid #44667f;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
}
.modal-content .table-user-details table thead .item-heading th {
  color: #84859d;
}
.modal-content .table-user-details table thead .table-heading th {
  color: #44667f;
}
.modal-content .table-user-details table tbody td {
  color: #222222;
}

.form-control.is-valid,
.was-validated .form-control:valid {
  background-image: none;
}

.order-select-input {
  align-items: flex-end;
}
.order-select-input button {
  text-decoration: none;
  border: none;
  background-color: #44667f;
  color: #fff;
  border-radius: 5px;
  padding: 5px 15px;
}

.modal-content .key {
  color: #707070;
  font-size: 16px;
}
.modal-content .value {
  font-size: 14px;
  color: #000000;
  font-weight: 600;
}

.wrapper-push-notification .main-section {
  justify-content: space-between;
}
.wrapper-push-notification .main-section h4 {
  font-size: 20px;
  color: #055d9d;
  font-weight: 600;
  margin-bottom: 20px;
}
.wrapper-push-notification .main-section h5 {
  font-size: 16px;
  color: #055d9d;
  font-weight: 600;
}
.wrapper-push-notification .left-section {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  width: calc(50% - 5px);
  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px;
  /* regular step */
}
.wrapper-push-notification .left-section p {
  font-size: 14px;
}
.wrapper-push-notification .left-section .step {
  padding: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background-color: cream;
}
.wrapper-push-notification .left-section .v-stepper {
  position: relative;
  /*   visibility: visible; */
}
.wrapper-push-notification .left-section .step .circle {
  background-color: white;
  border: 10px solid gray;
  border-radius: 100%;
  width: 32px;
  height: 32px;
  display: inline-block;
}
.wrapper-push-notification .left-section .step .line {
  top: 23px;
  left: 14px;
  /*   height: 120px; */
  height: 100%;
  position: absolute;
  border-left: 3px solid #055d9d;
}
.wrapper-push-notification .left-section .step.completed .circle {
  visibility: visible;
  background-color: rgb(6, 150, 215);
  border-color: rgb(6, 150, 215);
}
.wrapper-push-notification .left-section .step.completed .line {
  border-left: 3px solid #055d9d;
}
.wrapper-push-notification .left-section .step.active .circle {
  visibility: visible;
  border-color: #055d9d;
}
.wrapper-push-notification .left-section .step.empty .circle {
  visibility: hidden;
}
.wrapper-push-notification .left-section .step.empty .line {
  /*     visibility: hidden; */
  /*   height: 150%; */
  top: 0;
  height: 150%;
}
.wrapper-push-notification .left-section .step:last-child .line {
  border-left: 3px solid white;
  z-index: -1; /* behind the circle to completely hide */
}
.wrapper-push-notification .left-section .content {
  margin-left: 20px;
  display: inline-block;
}
.wrapper-push-notification .right-section {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  width: calc(50% - 5px);
  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px;
}
.wrapper-push-notification .right-section .form-control {
  border-radius: 0;
}
.wrapper-push-notification .right-section button {
  padding: 6px 25px;
  border: none;
  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);
  border-radius: 10px 0px;
  color: #ffffff;
}

.active-status {
  color: #15cb15;
}

.inactive-status {
  color: red;
}

.premium-status {
  color: #ffc107;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination-wrapper .entry-number label {
  color: #055d9d;
  font-size: 16px;
  font-weight: 600;
}
.pagination-wrapper .active > .page-link,
.pagination-wrapper .page-link.active {
  background-color: #055d9d;
}
.pagination-wrapper .pagination {
  color: #055d9d;
}

.access-heading {
  font-weight: 600;
  font-size: 16px;
}

.documents-wrapper .article-wrapper {
  max-height: calc(100vh - 163px) !important;
}
.documents-wrapper .inner-wrapper {
  max-height: calc(100vh - 263px);
  overflow-y: auto;
  margin-top: 20px;
}
.documents-wrapper .inner-wrapper .col-md-3 {
  margin-top: 0 !important;
}
.documents-wrapper .article-card {
  height: 360px;
}
.documents-wrapper .document-cards {
  margin-bottom: 15px;
  background-color: #fff;
  padding: 15px;
  border-radius: 10px;
}
.documents-wrapper .document-cards h5 {
  margin-bottom: 10px;
  color: #013053;
  font-weight: 600;
  border-bottom: 1px solid gray;
  padding-bottom: 5px;
}
.documents-wrapper .document-cards .img img {
  width: 100%;
  max-height: 200px;
  border-radius: 10px;
  height: 200px;
}

.document-preview-wrapper img {
  width: 100%;
  border-radius: 10px;
}

.back-btns svg {
  margin-right: 20px;
  margin-top: -5px;
}

.block-btn {
  border: none;
  background-color: #15cb15;
  color: #fff;
  border-radius: 5px;
  font-size: 16px;
  padding: 2px 10px;
  width: 120px;
}

.unblock-btn {
  width: 120px;
  border: none;
  font-size: 16px;
  background-color: rgba(255, 0, 0, 0.815);
  color: #fff;
  border-radius: 5px;
  padding: 2px 10px;
}

.profile-suggest-card-wrapper {
  margin-top: 10px;
}
.profile-suggest-card-wrapper .name {
  font-weight: 600;
  font-size: 16px;
  color: #013053;
}
.profile-suggest-card-wrapper .age {
  font-size: 16px;
  margin-left: 5px;
  font-weight: 600;
  color: #013053;
}
.profile-suggest-card-wrapper .heights {
  font-size: 14px;
  color: #013053;
}

.t-c-wrapper p {
  color: #013053;
  text-align: justify;
}

.basic-bg {
  color: #fff;
  display: inline-flex;
  width: 132px;
  justify-content: center;
  padding: 3px 10px;
  border-radius: 5px;
  background: linear-gradient(180deg, #03a731 0%, #027221 100%);
}

.Basic-Plus-bg {
  background: linear-gradient(180deg, #fdd504 0%, #b37600 100%);
  color: #fff;
  display: inline-flex;
  width: 132px;
  justify-content: center;
  padding: 3px 10px;
  border-radius: 5px;
}

.premium-bg {
  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);
  color: #fff;
  display: inline-flex;
  width: 132px;
  justify-content: center;
  padding: 3px 10px;
  border-radius: 5px;
}

.queries {
  margin-bottom: 15px;
  border-bottom: 1px solid gray;
}
.queries h5 {
  font-weight: 600;
  font-size: 16px;
}

.paln-card.p {
  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);
}

.paln-card.b {
  background: linear-gradient(180deg, #03a731 0%, #027221 100%);
}

.paln-card.bp {
  background: linear-gradient(180deg, #fdd504 0%, #b37600 100%);
}

.paln-card {
  text-align: center;
  padding: 10px;
  border-radius: 10px 0px;
}
.paln-card .name-c {
  color: #fff;
  font-weight: 600;
  font-size: 18px;
}

.active-plan {
  margin-left: 10px;
  margin-top: 15px;
}
.active-plan .key {
  color: #013053;
  font-size: 16px;
  margin-right: 10px;
  word-wrap: break-word; /* Ensures words break to fit the container */
  overflow-wrap: break-word; /* Helps in breaking long words */
  white-space: pre-wrap; /* Allows text to wrap normally, and respects line breaks */
}
.active-plan .value {
  color: #013053;
  font-size: 16px;
  font-weight: 600;
  margin-left: 10px;
}

.rdw-editor-main {
  border: 1px solid gray;
  height: 300px;
}

tbody tr {
  cursor: pointer;
}

.user-details-main-card .prf-img {
  position: absolute;
  bottom: -45px;
  left: 20px;
}
.user-details-main-card img {
  height: 35px;
  width: 90px;
  border-radius: 50%;
}
.user-details-main-card .paln-card.p {
  position: relative;
  border-radius: 10px;
  height: 90px;
}
.user-details-main-card .prf-name {
  margin-top: 50px;
}
.user-details-main-card .v_icon {
  width: 30px;
  height: 30px;
}
.user-details-main-card .u-details-inner-card {
  padding: 15px 0;
  background: #ffffff;
  border: 1px solid rgba(6, 116, 196, 0.3);
  border-radius: 10px 0px;
  overflow: hidden;
}
.user-details-main-card .u-details-inner-card h3 {
  padding-bottom: 10px;
  font-weight: 700;
  font-size: 18px;
  line-height: 17px;
  color: #013053;
  border-bottom: 1px solid rgba(172, 172, 172, 0.2);
}

.search-wrapper .label-select {
  color: #013053;
  font-weight: 600;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/dashboard.scss"],"names":[],"mappings":"AAEI;EACE,8BAAA;AADN;AAGI;EAUE,yBAAA;EACA,mBAAA;EACA,aAAA;AAVN;AAAM;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;AAER;AAII;EAaE,sBAAA;EAEA,yBAAA;EACA,mBAAA;EACA,aAAA;AAfN;AAAQ;EACE,yBAAA;AAEV;AADU;;EAEE,yBAAA;AAGZ;AAAQ;EACE,oCAAA;AAEV;AAMM;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,yBAAA;AAJR;AAYM;EACE,aAAA;AAVR;AAaM;EACE,WAAA;EACA,aAAA;AAXR;AAcM;EACE,YAAA;EACA,gBAAA;EACA,2BAAA;AAZR;AAgBM;EACE,gBAAA;AAdR;AAkBI;EACE,qBAAA;AAhBN;AAkBM;EACE,iDAAA;EACA,iBAAA;EAEA,WAAA;EAEA,aAAA;EAEA,sBAAA;EAEA,uBAAA;EAEA,yBAAA;EAEA,eAAA;EAEA,sBAAA;EAEA,kBAAA;EAEA,gBAAA;EAEA,mBAAA;EAEA,6BAAA;EAEA,sBAAA;AA5BR;AA8BQ;EACE,6DAAA;AA5BV;AA8BQ;EACE,6DAAA;AA5BV;AA8BQ;EACE,iEAAA;AA5BV;AA8BQ;EACE,mBAAA;EACA,UAAA;EAIA,kBAAA;EAEA,iBAAA;AAhCV;AAkCU;EAGE,kBAAA;EAEA,sBAAA;EAEA,gBAAA;EAEA,YAAA;EAEA,WAAA;EAEA,iBAAA;AAvCZ;AA4CM;EACE,UAAA;EAEA,4BAAA;EAEA,aAAA;EAEA,mBAAA;EAEA,mBAAA;EAEA,8BAAA;AA/CR;AAiDQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EAEA,qBAAA;AAhDV;AAmDQ;EACE,eAAA;EACA,eAAA;EAEA,gBAAA;EAEA,cAAA;EACA,eAAA;AAnDV;;AA0DA;EACE,aAAA;EAEA,8BAAA;EAEA,mBAAA;EAEA,mBAAA;AA1DF;;AA8DE;EACE,eAAA;EAEA,gBAAA;EAEA,cAAA;AA7DJ;;AAiEA;EACE,aAAA;AA9DF;AA+DE;EACE,eAAA;EAEA,gBAAA;EAEA,cAAA;AA/DJ;;AAoEE;;EAEE,qBAAA;EAEA,YAAA;EAEA,yBAAA;EAEA,WAAA;EAEA,mBAAA;EAEA,iBAAA;AAtEJ;;AA2EE;EACE,eAAA;AAxEJ;AA0EI;EACE,YAAA;EAEA,WAAA;EAEA,kBAAA;EAEA,iBAAA;EAEA,yBAAA;AA5EN;AA8EM;EACE,yBAAA;AA5ER;AA+EM;EACE,YAAA;EAEA,kBAAA;AA9ER;;AAoFA;EACE,gBAAA;EAEA,sBAAA;EAEA,aAAA;EAEA,mBAAA;AApFF;AAsFE;EAOE,gBAAA;AA1FJ;AA4FI;EACE,yBAAA;AA1FN;AA4FM;EACE,WAAA;AA1FR;AA+FM;EACE,qBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EAEA,yBAAA;AA9FR;AAgGQ;EACE,yBAAA;AA9FV;AAoGM;EASE,aAAA;EACA,gBAAA;EAEA,kBAAA;EAEA,yBAAA;AA5GR;AA+FQ;EACE,YAAA;EAEA,WAAA;EAEA,sBAAA;AA/FV;;AA6GA;EACE,kBAAA;AA1GF;;AA6GA;EACE,mBAAA;AA1GF;;AA6GA;EACE,iBAAA;EAEA,YAAA;EAEA,aAAA;AA5GF;;AA+GA;EACE,mBAAA;EAEA,aAAA;AA7GF;;AAgHA;EACE,UAAA;AA7GF;;AAgHA;EACE,gBAAA;AA7GF;;AAgHA;EACE,yBAAA;EAEA,sBAAA;AA9GF;AAgHE;EACE,yBAAA;EAEA,sBAAA;AA/GJ;;AAmHA;EACE,gBAAA;AAhHF;;AAmHA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAhHF;;AAoHE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAjHJ;;AAsHE;EACE,iEAAA;EACA,uBAAA;AAnHJ;AAqHE;EACE,oCAAA;AAnHJ;AAqHE;;EAEE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,iBAAA;AAnHJ;;AAwHE;EACE,eAAA;AArHJ;AAuHI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,iEAAA;EACA,uBAAA;AArHN;AAsHM;EACE,yBAAA;AApHR;AAuHM;EACE,YAAA;EACA,kBAAA;AArHR;AAyHE;EACE,eAAA;AAvHJ;AAyHI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,iEAAA;EACA,YAAA;EACA,uBAAA;AAvHN;AAwHM;EACE,yBAAA;AAtHR;AAyHM;EACE,YAAA;EACA,kBAAA;AAvHR;;AA6HA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;AA1HF;AA4HE;EACE,+BAAA;EACA,cAAA;AA1HJ;AA4HE;EACE,WAAA;EACA,gBAAA;EAQA,gBAAA;AAjIJ;AA6HI;EACE,yBAAA;AA3HN;AAgII;EACE,iDAAA;AA9HN;AAgIM;EACE,cAAA;EACA,gBAAA;AA9HR;AAmIM;EACE,yBAAA;AAjIR;AAkIQ;EACE,iDAAA;EACA,oBAAA;AAhIV;AAmIM;EACE,yBAAA;AAjIR;AAkIQ;EACE,iDAAA;EACA,oBAAA;AAhIV;AAmIM;EACE,yBAAA;AAjIR;AAkIQ;EACE,iDAAA;EACA,oBAAA;AAhIV;AAmIM;EAOE,aAAA;EACA,gBAAA;EACA,kBAAA;AAvIR;AA+HQ;EACE,YAAA;EACA,WAAA;EACA,sBAAA;AA7HV;;AA2IA;EACE,mBAAA;AAxIF;;AA2IA;EACE,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAxIF;;AA2IA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AAxIF;;AA2IA;EACE,UAAA;AAxIF;;AA2IA;EACE,gBAAA;AAxIF;;AA2IA;EACE,mBAAA;EACA,sBAAA;AAxIF;AA0IE;EACE,yBAAA;EACA,sBAAA;AAxIJ;;AA4IA;EACE,gBAAA;AAzIF;;AA+II;;EACE,eAAA;EACA,gBAAA;AA3IN;AA8IE;EACE,qBAAA;EACA,0BAAA;EACA,4BAAA;EACA,iEAAA;EACA,uBAAA;AA5IJ;AA8IE;EACE,8BAAA;EACA,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,2CAAA;AA5IJ;AA8IE;EACE,aAAA;EACA,eAAA;AA5IJ;AA6II;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AA3IN;AA8IE;EACE,eAAA;EACA,qBAAA;AA5IJ;AA6II;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AA3IN;AA4IM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AA1IR;AA4IM;EACE,eAAA;EACA,WAAA;EACA,cAAA;AA1IR;AA4IM;EACE,qBAAA;EACA,YAAA;EACA,WAAA;AA1IR;AA4IM;EACE,YAAA;EACA,WAAA;AA1IR;AA8IE;EACE,wBAAA;AA5IJ;AA6II;EAKE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AA/IN;AAwIM;EACE,YAAA;EACA,WAAA;AAtIR;AA8IE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AA5IJ;AA8IE;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AA5IJ;AA6II;EACE,uBAAA;EACA,WAAA;EACA,kBAAA;AA3IN;AA8IE;EACE,mBAAA;AA5IJ;AA6II;EACE,cAAA;EACA,eAAA;AA3IN;AA6II;;EAEE,eAAA;EACA,gBAAA;EACA,cAAA;AA3IN;AAgJE;EACE,gBAAA;AA9IJ;AA+II;EACE,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;AA7IN;AA8IM;;EAEE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA5IR;AAgJU;EACE,cAAA;AA9IZ;AAkJU;EACE,cAAA;AAhJZ;AAqJQ;EACE,cAAA;AAnJV;;AAyJA;;EAEE,sBAAA;AAtJF;;AAyJA;EACE,qBAAA;AAtJF;AAuJE;EACE,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AArJJ;;AA0JE;EACE,cAAA;EACA,eAAA;AAvJJ;AAyJE;EACE,eAAA;EAEA,cAAA;EACA,gBAAA;AAxJJ;;AA6JE;EACE,8BAAA;AA1JJ;AA2JI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAzJN;AA2JI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAzJN;AA4JE;EACE,2CAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EAqBA,iBAAA;AA9KJ;AA2JI;EACE,eAAA;AAzJN;AA4JI;EACE,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;EAEA,uBAAA;AA5JN;AA+JI;EACE,kBAAA;EACA,2BAAA;AA7JN;AAiKI;EACE,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AA/JN;AAiKI;EACE,SAAA;EACA,UAAA;EACA,qBAAA;EACA,YAAA;EAEA,kBAAA;EACA,8BAAA;AAhKN;AAmKI;EACE,mBAAA;EACA,kCAAA;EACA,8BAAA;AAjKN;AAoKI;EACE,8BAAA;AAlKN;AAqKI;EACE,mBAAA;EACA,qBAAA;AAnKN;AAsKI;EACE,kBAAA;AApKN;AAuKI;EACE,4BAAA;EACA,oBAAA;EACA,MAAA;EACA,YAAA;AArKN;AAwKI;EACE,4BAAA;EACA,WAAA,EAAA,yCAAA;AAtKN;AAyKI;EACE,iBAAA;EACA,qBAAA;AAvKN;AA0KE;EACE,2CAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AAxKJ;AA0KI;EACE,gBAAA;AAxKN;AA4KI;EACE,iBAAA;EACA,YAAA;EACA,iEAAA;EACA,uBAAA;EACA,cAAA;AA1KN;;AA+KA;EACE,cAAA;AA5KF;;AA8KA;EACE,UAAA;AA3KF;;AA8KA;EACE,cAAA;AA3KF;;AA6KA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA1KF;AA4KI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA1KN;AA6KE;;EAEE,yBAAA;AA3KJ;AAgLE;EACE,cAAA;AA9KJ;;AAiLA;EACE,gBAAA;EACA,eAAA;AA9KF;;AAiLE;EACE,0CAAA;AA9KJ;AAgLE;EACE,+BAAA;EACA,gBAAA;EACA,gBAAA;AA9KJ;AA+KI;EACE,wBAAA;AA7KN;AAgLE;EAEE,aAAA;AA/KJ;AAiLE;EACE,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AA/KJ;AAgLI;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;AA9KN;AAiLM;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;AA/KR;;AAsLE;EACE,WAAA;EACA,mBAAA;AAnLJ;;AAwLE;EACE,kBAAA;EAEA,gBAAA;AAtLJ;;AAyLA;EACE,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAtLF;;AAwLA;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,wCAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AArLF;;AAwLA;EACE,gBAAA;AArLF;AAsLE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AApLJ;AAsLE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AApLJ;AAsLE;EACE,eAAA;EACA,cAAA;AApLJ;;AAyLE;EACE,cAAA;EACA,mBAAA;AAtLJ;;AA0LA;EACE,WAAA;EACA,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6DAAA;AAvLF;;AAyLA;EACE,6DAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAtLF;;AAwLA;EACE,iEAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AArLF;;AAuLA;EACE,mBAAA;EACA,6BAAA;AApLF;AAqLE;EACE,gBAAA;EACA,eAAA;AAnLJ;;AAuLA;EACE,iEAAA;AApLF;;AAsLA;EACE,6DAAA;AAnLF;;AAqLA;EACE,6DAAA;AAlLF;;AAoLA;EACE,kBAAA;EAMA,aAAA;EACA,uBAAA;AAtLF;AAgLE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AA9KJ;;AAmLA;EACE,iBAAA;EACA,gBAAA;AAhLF;AAiLE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA,EAAA,6CAAA;EACF,yBAAA,EAAA,iCAAA;EACA,qBAAA,EAAA,2DAAA;AA/KF;AAiLE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA/KJ;;AAkLA;EACE,sBAAA;EACA,aAAA;AA/KF;;AAmLE;EACE,eAAA;AAhLJ;;AAoLE;EACE,kBAAA;EACA,aAAA;EACA,UAAA;AAjLJ;AAmLE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAjLJ;AAoLE;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;AAlLJ;AAoLE;EACE,gBAAA;AAlLJ;AAqLE;EACE,WAAA;EACA,YAAA;AAnLJ;AAsLE;EAEE,eAAA;EACA,mBAAA;EACA,wCAAA;EACA,uBAAA;EACA,gBAAA;AArLJ;AAsLI;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iDAAA;AApLN;;AA0LE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAvLJ","sourcesContent":[".dashboard-main {\n  .dashboard-wrapper {\n    .main-section {\n      justify-content: space-between;\n    }\n    .left-section {\n      // width: calc(50% - 5px);\n      h5 {\n        color: #44667f;\n        font-size: 18px;\n        margin-bottom: 20px;\n        font-weight: 600;\n        border-bottom: 1px solid #898e8e;\n        padding: 0 15px 15px 15px;\n      }\n      background-color: #ffffff;\n      border-radius: 10px;\n      padding: 15px;\n    }\n    .right-section {\n      .ineerCard {\n        .innerText {\n          background-color: #747b26;\n          .headingText,\n          .count {\n            color: #ffffff !important;\n          }\n        }\n        .innerIcon {\n          background-color: #ffffff !important;\n        }\n      }\n      width: calc(50% - 5px);\n\n      background-color: #ffffff;\n      border-radius: 10px;\n      padding: 15px;\n      h5 {\n        color: #44667f;\n        font-size: 18px;\n        margin-bottom: 20px;\n        font-weight: 600;\n        border-bottom: 1px solid #898e8e;\n        padding: 0 15px 15px 15px;\n      }\n    }\n\n    // RevenueCat KPI strip: the cards are content-sized by default, so labels\n    // that wrap to two lines (\"Active Subscriptions\") make those cards taller.\n    // Bootstrap already stretches the columns — make the cards fill them.\n    .rc-kpi-row {\n      > [class*=\"col-\"] {\n        display: flex;\n      }\n\n      .mainCards {\n        width: 100%;\n        display: flex;\n      }\n\n      .ineerCard {\n        height: 100%;\n        margin-bottom: 0; // default 20px would defeat height: 100%\n        justify-content: flex-start;\n      }\n\n      // Keeps one- and two-line labels the same height so the values line up.\n      .chart-heading {\n        min-height: 34px;\n      }\n    }\n\n    .mainCards {\n      text-decoration: none;\n\n      .ineerCard {\n        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n        max-height: 500px;\n\n        width: 100%;\n\n        display: flex;\n\n        flex-direction: column;\n\n        justify-content: center;\n\n        padding: 5px 0px 15px 5px;\n\n        cursor: pointer;\n\n        background-color: #fff;\n\n        position: relative;\n\n        overflow: hidden;\n\n        margin-bottom: 20px;\n\n        border: 0px solid transparent;\n\n        border-radius: 0.75rem;\n\n        .innerIcon.Basic {\n          background: linear-gradient(180deg, #03a731 0%, #027221 100%);\n        }\n        .innerIcon.Basic-plus {\n          background: linear-gradient(180deg, #fdd504 0%, #b37600 100%);\n        }\n        .innerIcon.Premium-User {\n          background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);\n        }\n        .innerIcon {\n          background: #055d9d;\n          width: 25%;\n\n          // padding: 10px;\n\n          text-align: center;\n\n          line-height: 80px;\n\n          svg {\n            // color: #fff;\n\n            text-align: center;\n\n            vertical-align: middle;\n\n            margin-top: 10px;\n\n            height: 50px;\n\n            width: 50px;\n\n            line-height: 80px;\n          }\n        }\n      }\n\n      .innerText {\n        width: 75%;\n\n        padding: 12px 50px 12px 30px;\n\n        display: flex;\n\n        flex-direction: row;\n\n        align-items: center;\n\n        justify-content: space-between;\n\n        .headingText {\n          color: #013053;\n          font-size: 18px;\n          font-weight: 600;\n\n          text-decoration: none;\n        }\n\n        .count {\n          margin-top: 0px;\n          font-size: 26px;\n\n          font-weight: 600;\n\n          color: #013053;\n          text-align: end;\n        }\n      }\n    }\n  }\n}\n\n.heading-btn-main {\n  display: flex;\n\n  justify-content: space-between;\n\n  align-items: center;\n\n  margin-bottom: 20px;\n}\n\n.heading-common {\n  label {\n    font-size: 24px;\n\n    font-weight: 700;\n\n    color: #84859d;\n  }\n}\n\n.chart-heading {\n  padding: 10px;\n  label {\n    font-size: 16px;\n\n    font-weight: 700;\n\n    color: #84859d;\n  }\n}\n\n.buttons-modal {\n  button,\n  a {\n    text-decoration: none;\n\n    border: none;\n\n    background-color: #44667f;\n\n    color: #fff;\n\n    border-radius: 10px;\n\n    padding: 5px 15px;\n  }\n}\n\n.admin-main {\n  .add-btn {\n    text-align: end;\n\n    button {\n      border: none;\n\n      color: #fff;\n\n      border-radius: 5px;\n\n      padding: 7px 10px;\n\n      background-color: #84859d;\n\n      &:hover {\n        background-color: #696a7d;\n      }\n\n      svg {\n        height: 20px;\n\n        margin-bottom: 2px;\n      }\n    }\n  }\n}\n\n.table-wrapper {\n  overflow-x: auto;\n\n  background-color: #fff;\n\n  padding: 20px;\n\n  border-radius: 10px;\n\n  table {\n    th {\n    }\n\n    td {\n    }\n\n    min-width: 900px;\n\n    thead {\n      background-color: #44667f;\n\n      th {\n        color: #fff;\n      }\n    }\n\n    .verify {\n      a {\n        display: inline-block;\n        width: 130px;\n        padding: 3px;\n        color: #fff;\n        text-decoration: none;\n        border-radius: 5px;\n\n        background-color: #84859d;\n\n        &:hover {\n          background-color: #696a7d;\n        }\n      }\n    }\n\n    .action {\n      .icon {\n        img {\n          height: 18px;\n\n          width: 18px;\n\n          vertical-align: middle;\n        }\n\n        margin: 0 3px;\n        padding: 2px 5px;\n\n        border-radius: 5px;\n\n        background-color: #84859d;\n      }\n    }\n  }\n}\n\ntable.dataTable thead th {\n  text-align: center;\n}\n\n.dataTables_wrapper .dataTables_length {\n  margin-bottom: 20px;\n}\n\n.dataTables_wrapper .dataTables_length select {\n  margin-left: 10px;\n\n  width: 150px;\n\n  outline: none;\n}\n\n.dataTables_wrapper .dataTables_filter input {\n  outline-offset: 0px;\n\n  outline: none;\n}\n\n.dataTables_empty {\n  color: red;\n}\n\n.dataTables_wrapper .dataTables_paginate {\n  margin-top: 20px;\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  background-color: #44667f;\n\n  color: #fff !important;\n\n  &:hover {\n    background-color: #44667f;\n\n    color: #fff !important;\n  }\n}\n\n.dataTables_wrapper .dataTables_info {\n  margin-top: 20px;\n}\n\n.heading-btn-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.heading-common {\n  label {\n    text-transform: uppercase;\n    font-size: 24px;\n    font-weight: 700;\n    color: #013053;\n    letter-spacing: 1px;\n  }\n}\n\n.buttons-modal {\n  button {\n    background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);\n    border-radius: 10px 0px;\n  }\n  a {\n    background-color: #055d9d !important;\n  }\n  button,\n  a {\n    text-decoration: none;\n    border: none;\n    color: #fff;\n    border-radius: 5px;\n    width: 100px;\n    display: inline-flex;\n    justify-content: center;\n    padding: 5px 15px;\n  }\n}\n\n.admin-main {\n  .add-btn {\n    text-align: end;\n\n    button {\n      border: none;\n      color: #fff;\n      padding: 7px 10px;\n      background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);\n      border-radius: 10px 0px;\n      &:hover {\n        background-color: #afb57d;\n      }\n\n      svg {\n        height: 20px;\n        margin-bottom: 2px;\n      }\n    }\n  }\n  .add-btnFalse {\n    text-align: end;\n\n    button {\n      border: none;\n      color: #fff;\n      padding: 7px 10px;\n      background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);\n      opacity: 0.5;\n      border-radius: 10px 0px;\n      &:hover {\n        background-color: #afb57d;\n      }\n\n      svg {\n        height: 20px;\n        margin-bottom: 2px;\n      }\n    }\n  }\n}\n\n.table-wrapper {\n  background-color: #fff;\n  padding: 20px;\n  border-radius: 10px;\n\n  .main-data-wrapper {\n    max-height: calc(100vh - 324px);\n    overflow: auto;\n  }\n  table {\n    width: 100%;\n    margin-bottom: 0;\n    th {\n    }\n\n    td {\n      color: #013053 !important;\n    }\n\n    min-width: 800px;\n\n    thead {\n      background-color: rgba(0, 126, 204, 0.3411764706);\n\n      th {\n        color: #055d9d;\n        font-weight: 600;\n      }\n    }\n\n    .action {\n      .view {\n        background-color: #e40288;\n        &:hover {\n          background-color: #e4028a83;\n          transition: all 0.2s;\n        }\n      }\n      .edit {\n        background-color: #e40288;\n        &:hover {\n          background-color: #e4028a83;\n          transition: all 0.2s;\n        }\n      }\n      .delete {\n        background-color: #e40288;\n        &:hover {\n          background-color: #e4028a83;\n          transition: all 0.2s;\n        }\n      }\n      .icon {\n        img {\n          height: 18px;\n          width: 18px;\n          vertical-align: middle;\n        }\n\n        margin: 0 3px;\n        padding: 2px 5px;\n        border-radius: 5px;\n      }\n    }\n  }\n}\n\ntable.dataTable thead th {\n}\n\n.dataTables_wrapper .dataTables_length {\n  margin-bottom: 20px;\n}\n\n.dataTables_wrapper .dataTables_length select {\n  margin-left: 10px;\n  width: 150px;\n  outline: none;\n  border-radius: 10px;\n}\n\n.dataTables_wrapper .dataTables_filter input {\n  outline-offset: 0px;\n  outline: none;\n  border-radius: 10px;\n}\n\n.dataTables_empty {\n  color: red;\n}\n\n.dataTables_wrapper .dataTables_paginate {\n  margin-top: 20px;\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button.current {\n  background: #055d9d;\n  color: #fff !important;\n\n  &:hover {\n    background-color: #055d9d;\n    color: #fff !important;\n  }\n}\n\n.dataTables_wrapper .dataTables_info {\n  margin-top: 20px;\n}\n\n.modal-content {\n  .plus-btn,\n  .minus-btn {\n    button {\n      font-size: 15px;\n      font-weight: 700;\n    }\n  }\n  .add-newSabaq-btn {\n    text-decoration: none;\n    width: calc(100% - 1.8rem);\n    margin: 0 0.9rem 15px 0.9rem;\n    background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);\n    border-radius: 10px 0px;\n  }\n  .sub-group-main {\n    margin-bottom: 15px !important;\n    margin: 0 0.9rem;\n    padding: 10px;\n    width: calc(100% - 1.8rem);\n    border-radius: 10px;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  }\n  .p-details-img {\n    display: flex;\n    flex-wrap: wrap;\n    img {\n      height: 90px;\n      width: 90px;\n      border-radius: 10px;\n      margin-right: 15px;\n    }\n  }\n  .product-img-main {\n    flex-wrap: wrap;\n    margin: 40px 0 30px 0;\n    .products {\n      margin-right: 20px;\n      margin-bottom: 20px;\n      width: 90px;\n      height: 90px;\n      padding: 10px 0;\n      text-align: center;\n      position: relative;\n      border: 1px dashed gray;\n      border-radius: 10px;\n      .cross {\n        position: absolute;\n        right: -8px;\n        top: -8px;\n        height: 15px;\n        width: 15px;\n      }\n      span {\n        font-size: 11px;\n        color: gray;\n        display: block;\n      }\n      svg {\n        display: inline-block;\n        height: 50px;\n        width: 50px;\n      }\n      .img-product {\n        height: 70px;\n        width: 70px;\n      }\n    }\n  }\n  .details-input {\n    width: calc(100% - 70px);\n    .remove {\n      img {\n        height: 20px;\n        width: 20px;\n      }\n      cursor: pointer;\n      position: absolute;\n      right: -55px;\n      bottom: 7px;\n    }\n  }\n  .modal-title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #013053;\n    text-transform: capitalize;\n  }\n  .check-input {\n    cursor: pointer;\n    margin-left: 30px;\n    margin-top: 8px;\n    display: flex;\n    align-items: center;\n    .form-check-input {\n      height: 30px !important;\n      width: 30px;\n      margin-right: 10px;\n    }\n  }\n  .user-detail {\n    margin-bottom: 15px;\n    label {\n      color: #84859d;\n      font-size: 14px;\n    }\n    span,\n    p {\n      font-size: 14px;\n      font-weight: 600;\n      color: #000000;\n      // margin-left: 30px;\n    }\n  }\n\n  .table-user-details {\n    overflow-x: auto;\n    table {\n      border: 1px solid #44667f;\n      border-collapse: collapse;\n      min-width: 1000px;\n      width: 100%;\n      th,\n      td {\n        padding: 7px 10px;\n        border: 1px solid #44667f;\n        text-align: center;\n        vertical-align: middle;\n        font-size: 14px;\n      }\n      thead {\n        .item-heading {\n          th {\n            color: #84859d;\n          }\n        }\n        .table-heading {\n          th {\n            color: #44667f;\n          }\n        }\n      }\n      tbody {\n        td {\n          color: #222222;\n        }\n      }\n    }\n  }\n}\n.form-control.is-valid,\n.was-validated .form-control:valid {\n  background-image: none;\n}\n\n.order-select-input {\n  align-items: flex-end;\n  button {\n    text-decoration: none;\n    border: none;\n    background-color: #44667f;\n    color: #fff;\n    border-radius: 5px;\n    padding: 5px 15px;\n  }\n}\n\n.modal-content {\n  .key {\n    color: #707070;\n    font-size: 16px;\n  }\n  .value {\n    font-size: 14px;\n\n    color: #000000;\n    font-weight: 600;\n  }\n}\n\n.wrapper-push-notification {\n  .main-section {\n    justify-content: space-between;\n    h4 {\n      font-size: 20px;\n      color: #055d9d;\n      font-weight: 600;\n      margin-bottom: 20px;\n    }\n    h5 {\n      font-size: 16px;\n      color: #055d9d;\n      font-weight: 600;\n    }\n  }\n  .left-section {\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    width: calc(50% - 5px);\n    background-color: #ffffff;\n    border-radius: 10px;\n    padding: 15px;\n\n    p {\n      font-size: 14px;\n    }\n\n    .step {\n      padding: 10px;\n\n      display: flex;\n      flex-direction: row;\n      justify-content: flex-start;\n\n      background-color: cream;\n    }\n\n    .v-stepper {\n      position: relative;\n      /*   visibility: visible; */\n    }\n\n    /* regular step */\n    .step .circle {\n      background-color: white;\n      border: 10px solid gray;\n      border-radius: 100%;\n      width: 32px;\n      height: 32px;\n      display: inline-block;\n    }\n    .step .line {\n      top: 23px;\n      left: 14px;\n      /*   height: 120px; */\n      height: 100%;\n\n      position: absolute;\n      border-left: 3px solid #055d9d;\n    }\n\n    .step.completed .circle {\n      visibility: visible;\n      background-color: rgb(6, 150, 215);\n      border-color: rgb(6, 150, 215);\n    }\n\n    .step.completed .line {\n      border-left: 3px solid #055d9d;\n    }\n\n    .step.active .circle {\n      visibility: visible;\n      border-color: #055d9d;\n    }\n\n    .step.empty .circle {\n      visibility: hidden;\n    }\n\n    .step.empty .line {\n      /*     visibility: hidden; */\n      /*   height: 150%; */\n      top: 0;\n      height: 150%;\n    }\n\n    .step:last-child .line {\n      border-left: 3px solid white;\n      z-index: -1; /* behind the circle to completely hide */\n    }\n\n    .content {\n      margin-left: 20px;\n      display: inline-block;\n    }\n  }\n  .right-section {\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    width: calc(50% - 5px);\n    background-color: #ffffff;\n    border-radius: 10px;\n    padding: 15px;\n\n    .form-control {\n      border-radius: 0;\n    }\n    .form-label {\n    }\n    button {\n      padding: 6px 25px;\n      border: none;\n      background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);\n      border-radius: 10px 0px;\n      color: #ffffff;\n    }\n  }\n}\n\n.active-status {\n  color: #15cb15;\n}\n.inactive-status {\n  color: red;\n}\n\n.premium-status {\n  color: #ffc107;\n}\n.pagination-wrapper {\n  margin-top: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  .entry-number {\n    label {\n      color: #055d9d;\n      font-size: 16px;\n      font-weight: 600;\n    }\n  }\n  .active > .page-link,\n  .page-link.active {\n    background-color: #055d9d;\n  }\n  .page-link {\n    // color:#055D9D ;\n  }\n  .pagination {\n    color: #055d9d;\n  }\n}\n.access-heading {\n  font-weight: 600;\n  font-size: 16px;\n}\n.documents-wrapper {\n  .article-wrapper{\n    max-height: calc(100vh - 163px) !important;\n  }\n  .inner-wrapper {\n    max-height: calc(100vh - 263px);\n    overflow-y: auto;\n    margin-top: 20px;\n    .col-md-3 {\n      margin-top: 0 !important;\n    }\n  }\n  .article-card{\n\n    height: 360px;\n  }\n  .document-cards {\n    margin-bottom: 15px;\n    background-color: #fff;\n    padding: 15px;\n    border-radius: 10px;\n    h5 {\n      margin-bottom: 10px;\n      color: #013053;\n      font-weight: 600;\n      border-bottom: 1px solid gray;\n      padding-bottom: 5px;\n    }\n    .img {\n      img {\n        width: 100%;\n        max-height: 200px;\n        border-radius: 10px;\n        height: 200px;\n      }\n    }\n  }\n}\n\n.document-preview-wrapper {\n  img {\n    width: 100%;\n    border-radius: 10px;\n  }\n}\n\n.back-btns {\n  svg {\n    margin-right: 20px;\n    // height: 40px;\n    margin-top: -5px;\n  }\n}\n.block-btn {\n  border: none;\n  background-color: #15cb15;\n  color: #fff;\n  border-radius: 5px;\n  font-size: 16px;\n  padding: 2px 10px;\n  width: 120px;\n}\n.unblock-btn {\n  width: 120px;\n  border: none;\n  font-size: 16px;\n  background-color: rgba(255, 0, 0, 0.815);\n  color: #fff;\n  border-radius: 5px;\n  padding: 2px 10px;\n}\n\n.profile-suggest-card-wrapper {\n  margin-top: 10px;\n  .name {\n    font-weight: 600;\n    font-size: 16px;\n    color: #013053;\n  }\n  .age {\n    font-size: 16px;\n    margin-left: 5px;\n    font-weight: 600;\n    color: #013053;\n  }\n  .heights {\n    font-size: 14px;\n    color: #013053;\n  }\n}\n\n.t-c-wrapper {\n  p {\n    color: #013053;\n    text-align: justify;\n  }\n}\n\n.basic-bg {\n  color: #fff;\n  display: inline-flex;\n  width: 132px;\n  justify-content: center;\n  padding: 3px 10px;\n  border-radius: 5px;\n  background: linear-gradient(180deg, #03a731 0%, #027221 100%);\n}\n.Basic-Plus-bg {\n  background: linear-gradient(180deg, #fdd504 0%, #b37600 100%);\n  color: #fff;\n  display: inline-flex;\n  width: 132px;\n  justify-content: center;\n  padding: 3px 10px;\n  border-radius: 5px;\n}\n.premium-bg {\n  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);\n  color: #fff;\n  display: inline-flex;\n  width: 132px;\n  justify-content: center;\n  padding: 3px 10px;\n  border-radius: 5px;\n}\n.queries {\n  margin-bottom: 15px;\n  border-bottom: 1px solid gray;\n  h5 {\n    font-weight: 600;\n    font-size: 16px;\n  }\n}\n\n.paln-card.p {\n  background: linear-gradient(270deg, #e40288 0.63%, #055d9d 97.5%);\n}\n.paln-card.b {\n  background: linear-gradient(180deg, #03a731 0%, #027221 100%);\n}\n.paln-card.bp {\n  background: linear-gradient(180deg, #fdd504 0%, #b37600 100%);\n}\n.paln-card {\n  text-align: center;\n  .name-c {\n    color: #fff;\n    font-weight: 600;\n    font-size: 18px;\n  }\n  padding: 10px;\n  border-radius: 10px 0px;\n}\n.active-plan {\n  margin-left: 10px;\n  margin-top: 15px;\n  .key {\n    color: #013053;\n    font-size: 16px;\n    margin-right: 10px;\n    word-wrap: break-word; /* Ensures words break to fit the container */\n  overflow-wrap: break-word; /* Helps in breaking long words */\n  white-space: pre-wrap; /* Allows text to wrap normally, and respects line breaks */\n  }\n  .value {\n    color: #013053;\n    font-size: 16px;\n    font-weight: 600;\n    margin-left: 10px;\n  }\n}\n.rdw-editor-main {\n  border: 1px solid gray;\n  height: 300px;\n}\n\ntbody {\n  tr {\n    cursor: pointer;\n  }\n}\n.user-details-main-card {\n  .prf-img {\n    position: absolute;\n    bottom: -45px;\n    left: 20px;\n  }\n  img {\n    height: 35px;\n    width: 90px;\n    border-radius: 50%;\n  }\n\n  .paln-card.p {\n    position: relative;\n    border-radius: 10px;\n    height: 90px;\n  }\n  .prf-name {\n    margin-top: 50px;\n  }\n\n  .v_icon {\n    width: 30px;\n    height: 30px;\n  }\n\n  .u-details-inner-card {\n    \n    padding: 15px 0;\n    background: #ffffff;\n    border: 1px solid rgba(6, 116, 196, 0.3);\n    border-radius: 10px 0px;\n    overflow: hidden;\n    h3 {\n      padding-bottom: 10px;\n      font-weight: 700;\n      font-size: 18px;\n      line-height: 17px;\n      color: #013053;\n      border-bottom: 1px solid rgba(172, 172, 172, 0.2);\n    }\n  }\n}\n\n.search-wrapper {\n  .label-select {\n    color: #013053;\n    font-weight: 600;\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
